export var h5Router = [
//北京疾控一个新问卷
{
  path: "/h5/questionnairejzcw-v2024",
  meta: {
    title: "中国儿童青少年脊柱侧弯流行病学调查表"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnairejzcw-v2024");
  },
  hidden: true
},
//新版调查问卷 start
{
  path: "/h5/questionnaire40-v2024rn",
  meta: {
    title: "调查问卷4-2024只读"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaire40-v2024readonly");
  },
  hidden: true
}, {
  path: "/h5/questionnaire40-v2024",
  meta: {
    title: "调查问卷4-2024"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaire40-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire33-v2024",
  meta: {
    title: "调查问卷3-3-2024大学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire33-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire33-v2025",
  meta: {
    title: "调查问卷3-3-2025大学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire33-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire32-v2024",
  meta: {
    title: "调查问卷3-2-2024中学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire32-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire32-v2025",
  meta: {
    title: "调查问卷3-2-2025中学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire32-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire32-v2025-hlj",
  meta: {
    title: "调查问卷3-2-2025中学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire32-v2025-hlj");
  },
  hidden: true
}, {
  path: "/h5/questionnaire31-v2024",
  meta: {
    title: "调查问卷3-1-2024小学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire31-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire31-v2025",
  meta: {
    title: "调查问卷3-1-2025小学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire31-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire31-v2025-hlj",
  meta: {
    title: "调查问卷3-1-2025小学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire31-v2025-hlj");
  },
  hidden: true
}, {
  path: "/h5/questionnaire11-v2024",
  meta: {
    title: "调查问卷1-1-2024"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire11-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire12-v2024",
  meta: {
    title: "调查问卷1-2-2024"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire12-v2024");
  },
  hidden: true
}, {
  path: "/h5/questionnaire13-v2024",
  meta: {
    title: "调查问卷1-3-2024"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire13-v2024");
  },
  //
  hidden: true
}, {
  path: "/h5/questionnaire11-v2025",
  meta: {
    title: "调查问卷1-1-2025"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire11-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire12-v2025",
  meta: {
    title: "调查问卷1-2-2025"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire12-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire13-v2025",
  meta: {
    title: "调查问卷1-3-2025"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire13-v2025");
  },
  //
  hidden: true
}, {
  path: "/h5/questionnaire13-v2025-ah",
  meta: {
    title: "安徽版调查问卷1-3-2025"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire13-v2025-ah");
  },
  //
  hidden: true
}, {
  path: "/h5/new-questionnaire1-v2",
  meta: {
    title: "新版调查问卷1-1"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireH");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaire2-v2",
  meta: {
    title: "新版调查问卷1-2"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireI");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireB-v2",
  meta: {
    title: "2023小学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewB");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireC-v2",
  meta: {
    title: "2023中学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewC");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireD-v2",
  meta: {
    title: "2023大学版"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewD");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireB-v3",
  meta: {
    title: "2023小学版补充营养调查"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewCustomizationB");
  },
  hidden: true
}, {
  path: "/h5/questionnairebj-yyjc-v2025",
  meta: {
    title: "北京市中小学生营养健康状况监测调查表"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnairebj-yyjc-v2025");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireC-v3",
  meta: {
    title: "2023中学版补充营养调查"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewCustomizationC");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireD-v3",
  meta: {
    title: "2023大学版（安徽）"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewCustomizationD");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireA-v2",
  meta: {
    title: "调查问卷4-2"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaireA");
  },
  hidden: true
}, {
  path: "/h5/new-questionnaireB-v4",
  meta: {
    title: "2023小学版（江苏）"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewBForJS/questionnaireNewB");
  },
  hidden: true
},
// {
//   path: "/h5/new-questionnaireC-v4",
//   meta: { title: "2023中学版（江苏）" },
//   component: () => import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewC"),
//   hidden: true
// },
// {
//   path: "/h5/new-questionnaireD-v4",
//   meta: { title: "2023大学版（江苏）" },
//   component: () => import("@/views/h5/questionnaireNew/questionnaireList/questionnaireNewD"),
//   hidden: true
// },
{
  path: "/h5/questionnaireI-v2",
  meta: {
    title: "学生近视发生发展相关因素调查表"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnaireC");
  },
  hidden: true
}, {
  path: "/h5/questionnaireJ-v2",
  meta: {
    title: "学生近视发生发展相关因素调查表"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnaireD");
  },
  hidden: true
}, {
  path: "/h5/questionnaireI-v3",
  meta: {
    title: "学生近视发生发展相关因素调查表（新版）"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnaireC-v3");
  },
  hidden: true
}, {
  path: "/h5/questionnaireJ-v3",
  meta: {
    title: "学生近视发生发展相关因素调查表（新版）"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnaireD-v3");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjA-v2",
  meta: {
    title: "知情同意书"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForYsl/questionnaireYsl");
  },
  hidden: true
}, {
  path: "/h5/questionnaire-zz",
  meta: {
    title: "郑州市第一人民医院调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForZZ/questionnaireZz");
  },
  hidden: true
},
// {
//   path: "/h5/new-questionnaireB-v5",
//   meta: { title: "2023小学版（南京）" },
//   component: () => import("@/views/h5/questionnaireNew/customization/PageNewBForNJ/questionnaireNewB"),
//   hidden: true
// },
// {
//   path: "/h5/new-questionnaireC-v5",
//   meta: { title: "2023中学版（南京）" },
//   component: () => import("@/views/h5/questionnaireNew/customization/PageNewBForNJ/questionnaireNewC"),
//   hidden: true
// },
{
  path: "/h5/new-questionnaire-xm",
  meta: {
    title: "学生生活社会环境和心理健康监测"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/customization/PageNewForXM/questionnaireForXm");
  },
  hidden: true
},
//新版调查问卷 end
{
  path: "/h5/questionnaireNew1",
  meta: {
    title: "调查问卷1-1"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireH");
  },
  hidden: true
}, {
  path: "/h5/questionnaireNew2",
  meta: {
    title: "调查问卷1-2"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireI");
  },
  hidden: true
}, {
  path: "/h5/404",
  meta: {
    title: "404"
  },
  component: function component() {
    return import("@/views/h5/404");
  },
  hidden: true
},
// 泰安表
{
  path: "/h5/questionnaireNewTa",
  meta: {
    title: "学龄前儿童（3-6岁）视力情况及影响因素"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewTa");
  },
  hidden: true
},
// 泰安表脊柱基础信息调查表
{
  path: "/h5/questionnaireNewTaJz",
  meta: {
    title: "2025年儿童青少年脊柱健康齐鲁行泰安站基本情况调查"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewTaJz");
  },
  hidden: true
}, {
  path: "/h5/questionnaire",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire");
  },
  hidden: true
}, {
  path: "/h5/questionnaireweb",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireweb");
  },
  hidden: true
}, {
  path: "/h5/questionnaireA",
  meta: {
    title: "调查问卷A"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireA");
  },
  hidden: true
},
// 临时
{
  path: "/h5/questionnairestatisticsWH",
  meta: {
    title: "调查问卷F"
  },
  component: function component() {
    return import("@/views/gov/questionnairestatisticsWH");
  },
  hidden: true
},
// 康利统计用
{
  path: "/h5/questionnairestatisticsWH2",
  meta: {
    title: "调查问卷F"
  },
  component: function component() {
    return import("@/views/gov/questionnairestatisticsWH2");
  },
  hidden: true
}, {
  path: "/h5/questionnaireAecho",
  meta: {
    title: "调查问卷A"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireAecho");
  },
  hidden: true
}, {
  path: "/h5/questionnaireB",
  meta: {
    title: "调查问卷B"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewB");
  },
  hidden: true
}, {
  //调查问卷-----------------------
  path: "/h5/questionnaireC",
  meta: {
    title: "调查问卷C"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewC");
  },
  hidden: true
}, {
  path: "/h5/questionnaireD",
  meta: {
    title: "调查问卷D"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewD");
  },
  hidden: true
},
// 定制版表3-1
{
  path: "/h5/customization/questionnaireB",
  meta: {
    title: "调查问卷B"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewCustomizationB");
  },
  hidden: true
},
// 定制版表3-2
{
  path: "/h5/customization/questionnaireC",
  meta: {
    title: "调查问卷C"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewCustomizationC");
  },
  hidden: true
},
// 定制版表3-3
{
  path: "/h5/customization/questionnaireD",
  meta: {
    title: "调查问卷D"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewCustomizationD");
  },
  hidden: true
},
// 家长填写调查问卷
{
  path: "/h5/questionnaireE",
  meta: {
    title: "调查问卷E"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireE");
  },
  hidden: true
},
// 乌海定制调查问卷
{
  path: "/h5/questionnaireF",
  meta: {
    title: "调查问卷F"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireF");
  },
  hidden: true
},
// 同仁定制调查问卷
{
  path: "/h5/questionnaireG",
  meta: {
    title: "调查问卷G"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireG");
  },
  hidden: true
}, {
  path: "/h5/questionnairebj",
  meta: {
    title: "2022年学生居家期间近视及影响因素调查表"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/questionnaireNewBj");
  },
  hidden: true
}, {
  path: "/h5/questionnaireH",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireB");
  },
  hidden: true
}, {
  path: "/h5/questionnaireI",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireC");
  },
  hidden: true
}, {
  path: "/h5/questionnaireJ",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireD");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjA",
  meta: {
    title: "知情同意书"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireStB");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjB",
  meta: {
    title: "知情同意书（散瞳非随访样本）"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireStC");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjC",
  meta: {
    title: "知情同意书（非散瞳非随访样本）"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireFstC");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjD",
  meta: {
    title: "知情同意书（非散瞳随访样本）"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireFstB");
  },
  hidden: true
}, {
  path: "/h5/questionnairebjZysf",
  meta: {
    title: "儿童青少年中医手法干预近视知情同意书"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaireList/customization/questionnaireZysf");
  },
  hidden: true
}, {
  path: "/h5/questionnaire1",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire1");
  },
  hidden: true
}, {
  path: "/h5/questionnairehb",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehb");
  },
  hidden: true
}, {
  path: "/h5/questionnairehb2025",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehb2025");
  },
  hidden: true
}, {
  path: "/h5/questionnairehb2025ah",
  meta: {
    title: "调查问卷-安徽"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehb2025ah");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroom",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomNew");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroom25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomNew25");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroom25ah",
  meta: {
    title: "调查问卷-安徽"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomNew25ah");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroombj",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomNewbj");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroombj25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomNewbj25");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForYear",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForYear");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForYear25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForYear25");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForYear25ah",
  meta: {
    title: "调查问卷-安徽"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForYear25ah");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForYearbj",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForYearbj");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForYearbj25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForYearbj25");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForTwelve",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForTwelve");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForTwelve25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForTwelve25");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForTwelve25ah",
  meta: {
    title: "调查问卷-安徽"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForTwelve25ah");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForTwelvebj",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForTwelvebj");
  },
  hidden: true
}, {
  path: "/h5/questionnairehbclassroomForTwelvebj25",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairehbclassroomForTwelvebj25");
  },
  hidden: true
}, {
  path: "/h5/questionnaire2",
  meta: {
    title: "调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnaire2");
  },
  hidden: true
}, {
  path: "/h5/questionnairelist",
  meta: {
    title: "调查问卷列表"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairelist");
  },
  hidden: true
}, {
  path: "/h5/questionhislist",
  meta: {
    title: "调查问卷答题列表"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionhislist");
  },
  hidden: true
}, {
  path: "/h5/questionhisdetail",
  meta: {
    title: "调查问卷答题详情"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionhisdetail");
  },
  hidden: true
}, {
  path: "/h5/questionnairelist1",
  meta: {
    title: "调查问卷列表"
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairelist1");
  },
  hidden: true
}, {
  path: "/h5/questionnairepic",
  meta: {
    title: ""
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairepic");
  },
  hidden: true
}, {
  path: "/h5/questionnairesuss",
  meta: {
    title: ""
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairesuss");
  },
  hidden: true
}, {
  path: "/h5/questionnairewebsuss",
  meta: {
    title: ""
  },
  component: function component() {
    return import("@/views/h5/questionnaire/questionnairewebsuss");
  },
  hidden: true
}, {
  path: "/h5/articledetail",
  meta: {
    title: "文章详情"
  },
  component: function component() {
    return import("@/views/h5/articledetail");
  },
  hidden: true
}, {
  path: "/h5/visualtraining",
  meta: {
    title: "视力训练"
  },
  component: function component() {
    return import("@/views/h5/visualtraining");
  },
  hidden: true
},
//
{
  path: "/h5/syslogin",
  meta: {
    title: "系统登录"
  },
  component: function component() {
    return import("@/views/h5/syslogin");
  },
  hidden: true
}, {
  path: "/h5/sysmain",
  meta: {
    title: "系统管理主页"
  },
  component: function component() {
    return import("@/views/h5/sysmain");
  },
  hidden: true
}, {
  path: "/h5/sysdetail",
  meta: {
    title: "系统管理消息详情"
  },
  component: function component() {
    return import("@/views/h5/sysdetail");
  },
  hidden: true
}, {
  path: "/h5/search",
  meta: {
    title: ""
  },
  component: function component() {
    return import("@/views/h5/search");
  },
  hidden: true
}, {
  path: "/h5/search1",
  meta: {
    title: "电子档案"
  },
  component: function component() {
    return import("@/views/h5/search1");
  },
  hidden: true
}, {
  path: "/h5/searchpage",
  meta: {
    title: "查报告"
  },
  component: function component() {
    return import("@/views/h5/data-search");
  },
  hidden: true
}, {
  path: "/h5/newfile1",
  meta: {
    title: "视力档案"
  },
  component: function component() {
    return import("@/views/h5/newfile1");
  },
  hidden: true
}, {
  path: "/h5/bindequipment",
  meta: {
    title: "绑定设备"
  },
  component: function component() {
    return import("@/views/h5/bindequipment");
  },
  hidden: true
}, {
  path: "/h5/bindequipmentadd",
  meta: {
    title: "绑定设备"
  },
  component: function component() {
    return import("@/views/h5/bindequipmentadd");
  },
  hidden: true
}, {
  path: "/h5/equipmentadd",
  meta: {
    title: "添加用眼行为数据"
  },
  component: function component() {
    return import("@/views/h5/equipmentadd");
  },
  hidden: true
}, {
  path: "/h5/equipmentsessage",
  meta: {
    title: "用眼建议"
  },
  component: function component() {
    return import("@/views/h5/equipmentsessage");
  },
  hidden: true
}, {
  path: "/h5/equipmentreport",
  meta: {
    title: "健康用眼报告"
  },
  component: function component() {
    return import("@/views/h5/equipmentreport");
  },
  hidden: true
}, {
  path: "/h5/addfile",
  meta: {
    title: "编辑"
  },
  component: function component() {
    return import("@/views/h5/addfile");
  },
  hidden: true
}, {
  path: "/h5/robot",
  meta: {
    title: "智能问诊"
  },
  component: function component() {
    return import("@/views/h5/robot");
  },
  hidden: true
}, {
  path: "/h5/customerservice",
  meta: {
    title: "在线问诊"
  },
  component: function component() {
    return import("@/views/h5/customerservice");
  },
  hidden: true
},
// 公众号
{
  path: "/h5/customerservicescreen",
  meta: {
    title: "一对一问诊"
  },
  component: function component() {
    return import("@/views/h5/customerservicescreen");
  },
  hidden: true
}, {
  path: "/h5/filelogdetail",
  meta: {
    title: "健康档案"
  },
  component: function component() {
    return import("@/views/h5/filelogdetail");
  },
  hidden: true
}, {
  path: "/h5/file/qrcode-list-lz",
  meta: {
    title: "健康档案"
  },
  component: function component() {
    return import("@/views/h5/data-search/qrcode-list-lz");
  },
  hidden: true
}, {
  path: "/h5/recheckdetail",
  meta: {
    title: "复测结果"
  },
  component: function component() {
    return import("@/views/h5/recheckdetail");
  },
  hidden: true
}, {
  path: "/h5/emr",
  meta: {
    title: "电子病历"
  },
  component: function component() {
    return import("@/views/h5/emr");
  },
  hidden: true
}, {
  path: "/h5/hospitalDetail",
  name: "hospitalDetail",
  component: function component() {
    return import("@/views/h5/hospitalDetail");
  },
  meta: {
    title: "医院详情"
  },
  hidden: true
}, {
  path: "/h5/dataptf",
  name: "dataptf",
  component: function component() {
    return import("@/views/h5/datareport/dataptf");
  },
  meta: {
    title: "数据报告"
  },
  hidden: true
}, {
  path: "/h5/dataptf1",
  name: "dataptf1",
  component: function component() {
    return import("@/views/h5/datareport/dataptf1");
  },
  meta: {
    title: "数据报告"
  },
  hidden: true
}, {
  path: "/h5/dataptfphone",
  name: "dataptfphone",
  component: function component() {
    return import("@/views/h5/datareport/dataptfphone");
  },
  meta: {
    title: "数据报告"
  },
  hidden: true
},
// 全国眼健康调查专用查询
{
  path: "/h5/province15_searchpage",
  name: "province15_searchpage",
  component: function component() {
    return import("@/views/h5/province15/searchpage");
  },
  meta: {
    title: "流调查询"
  },
  hidden: true
},
// 全国眼健康调查连接眼护士
{
  path: "/h5/province15SearchPageb",
  name: "province15_searchpageb",
  component: function component() {
    return import("@/views/h5/province15/searchpageb");
  },
  meta: {
    title: "查报告"
  },
  hidden: true
}, {
  path: "/h5/province15_newfile",
  name: "province15_newfile",
  component: function component() {
    return import("@/views/h5/province15/newfile");
  },
  meta: {
    title: "全国眼健康调查报告"
  },
  hidden: true
}, {
  path: "/h5/data/search",
  name: "datasearch",
  component: function component() {
    return import("@/views/h5/data-search/index");
  },
  meta: {
    title: "健康档案查询"
  },
  hidden: true
}, {
  path: "/h5/data/sportMonitor",
  name: "sportMonitor",
  component: function component() {
    return import("@/views/h5/data-search/sportmonitor");
  },
  meta: {
    title: "运动行为监测"
  },
  hidden: true
}, {
  path: "/h5/data/file",
  name: "datafile",
  component: function component() {
    return import("@/views/h5/data-search/fileNew");
  },
  meta: {
    title: "健康档案"
  },
  hidden: true
}, {
  path: "/h5/data/commonDisease",
  name: "common-disease",
  component: function component() {
    return import("@/views/h5/data-search/components/commonDisease");
  },
  meta: {
    title: "学生常见病检查"
  },
  hidden: true
}, {
  path: "/h5/data/physicalExamination",
  name: "physical-examination",
  component: function component() {
    return import("@/views/h5/data-search/components/physicalExamination");
  },
  meta: {
    title: "中小学生体检"
  },
  hidden: true
}, {
  path: "/h5/data/setting",
  name: "h5-setting",
  component: function component() {
    return import("@/views/h5/data-search/components/setting");
  },
  meta: {
    title: "设置"
  },
  hidden: true
}, {
  path: "/h5/data/snodoc",
  name: "h5-datafile",
  component: function component() {
    return import("@/views/h5/data-search/sno-doc");
  },
  meta: {
    title: "档案查询码"
  },
  hidden: true
}, {
  path: "/h5/data/visionscreening/list",
  name: "vision-screening-list",
  component: function component() {
    return import("@/views/h5/data-search/data/vision-screening-list");
  },
  meta: {
    title: "视力筛查"
  },
  hidden: true
}, {
  path: "/h5/data/medicalStudents/detail",
  name: "medical-students-list",
  component: function component() {
    return import("@/views/h5/data-search/data/medical-students-list");
  },
  meta: {
    title: "中小学生健康体检"
  },
  hidden: true
}, {
  path: "/h5/data/visionscreening/detail",
  name: "vision-screening-detail",
  component: function component() {
    return import("@/views/h5/data-search/data/vision-screening-detail");
  },
  meta: {
    title: "视力筛查数据"
  },
  hidden: true
}, {
  path: "/h5/data/visionscreening/report",
  name: "vision-screening-report",
  component: function component() {
    return import("@/views/h5/data-search/data/vision-screening-report");
  },
  meta: {
    title: "报告解读"
  },
  hidden: TextTrackCue
}, {
  path: "/h5/data/medicalStudents/report",
  name: "medical-students-report",
  component: function component() {
    return import("@/views/h5/data-search/data/medical-students-report");
  },
  meta: {
    title: "体检报告"
  },
  hidden: true
}, {
  path: "/h5/data/commonill/list",
  name: "common-ill-list",
  component: function component() {
    return import("@/views/h5/data-search/data/common-ill-list");
  },
  meta: {
    title: "常见病检查"
  },
  hidden: true
}, {
  path: "/h5/data/commonill/detail",
  name: "common-ill-detail",
  component: function component() {
    return import("@/views/h5/data-search/data/common-ill-detail");
  },
  meta: {
    title: "常见病检查报告"
  },
  hidden: true
}, {
  path: "/h5/data/history/list",
  name: "medical-students-history-list",
  component: function component() {
    return import("@/views/h5/data-search/data/medical-students-history-list");
  },
  meta: {
    title: "体检记录"
  },
  hidden: true
}, {
  path: "/h5/data/physique",
  name: "basic-physique",
  component: function component() {
    return import("@/views/h5/data-search/components/basicPhysique");
  },
  meta: {
    // title: "基础体质报告"
    title: "健康档案"
  },
  hidden: true
}, {
  path: "/h5/data/ent",
  name: "ent",
  component: function component() {
    return import("@/views/h5/data-search/components/ent");
  },
  meta: {
    title: "五官科报告"
  },
  hidden: true
}, {
  path: "/h5/data/internalmedicine",
  name: "internal-medicine",
  component: function component() {
    return import("@/views/h5/data-search/components/internalMedicine");
  },
  meta: {
    title: "内科报告"
  },
  hidden: true
}, {
  path: "/h5/data/surgical",
  name: "surgical",
  component: function component() {
    return import("@/views/h5/data-search/components/surgical");
  },
  meta: {
    title: "外科报告"
  },
  hidden: true
}, {
  path: "/h5/data/laboratorymedicine",
  name: "laboratory-medicine",
  component: function component() {
    return import("@/views/h5/data-search/components/laboratoryMedicine");
  },
  meta: {
    title: "检验科报告"
  },
  hidden: true
}, {
  path: "/h5/data/behaviormonitoring",
  name: "behavior-monitoring-list",
  component: function component() {
    return import("@/views/h5/data-search/data/behavior-monitoring");
  },
  meta: {
    title: "行为监测"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/login",
  name: "ampminspection-login",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/login");
  },
  meta: {
    title: "晨午检上报登录"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/studentlist",
  name: "ampminspection-student-list",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/student-list");
  },
  meta: {
    title: "晨午检上报"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/student",
  name: "ampminspection-student",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/student");
  },
  meta: {
    title: "晨午检上报"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/school/gradelist",
  name: "ampminspection-gradelist",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/school/grade-list");
  },
  meta: {
    title: "年级列表"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/school/classlist",
  name: "ampminspection-classlist",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/school/class-list");
  },
  meta: {
    title: "班列表"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/school/studentlist",
  name: "ampminspection-studentlist",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/school/student-list");
  },
  meta: {
    title: "学生列表"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/school/unusuallist",
  name: "ampminspection-unusual-list",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/school/unusual-list");
  },
  meta: {
    title: "年级列表"
  },
  hidden: true
}, {
  path: "/h5/ampminspection/school/unusualreport",
  name: "ampminspection-unusual-report",
  component: function component() {
    return import("@/views/h5/am-pm-inspection/school/unusual-report");
  },
  meta: {
    title: "学生详情"
  },
  hidden: true
}, {
  path: "/h5/inspection/inspectionlist",
  name: "inspectionlist",
  component: function component() {
    return import("@/views/h5/inspection/inspectionlist");
  },
  meta: {
    title: "过程质控"
  },
  hidden: true
}, {
  path: "/h5/inspection/inspectiondetail",
  name: "inspectiondetail",
  component: function component() {
    return import("@/views/h5/inspection/inspectiondetail");
  },
  meta: {
    title: "质量控制"
  },
  hidden: true
}, {
  path: "/h5/inspection/equipmentlist",
  name: "equipmentlist",
  component: function component() {
    return import("@/views/h5/inspection/equipmentlist");
  },
  meta: {
    title: "设备质控"
  },
  hidden: true
}, {
  path: "/h5/inspection/equipmentdetail",
  name: "equipmentdetail",
  component: function component() {
    return import("@/views/h5/inspection/equipmentdetail");
  },
  meta: {
    title: "设备质控"
  },
  hidden: true
}, {
  path: "/h5/inspection/gradelist",
  name: "gradelist",
  component: function component() {
    return import("@/views/h5/inspection/gradelist");
  },
  meta: {
    title: "学生列表"
  },
  hidden: true
}, {
  path: "/h5/inspection/studentlist",
  name: "studentlist",
  component: function component() {
    return import("@/views/h5/inspection/studentlist");
  },
  meta: {
    title: "学生列表"
  },
  hidden: true
}, {
  path: "/h5/search-file/filedetail",
  name: "search-filedetail",
  component: function component() {
    return import("@/views/h5/search-file/filedetail");
  },
  meta: {
    title: "档案查询"
  },
  hidden: true
}, {
  path: "/h5/search-file",
  name: "search-article",
  component: function component() {
    return import("@/views/h5/search-file/index");
  },
  meta: {
    title: "系统登录"
  },
  hidden: true
}, {
  path: "/h5/inspection/studentassess",
  name: "studentassess",
  component: function component() {
    return import("@/views/h5/inspection/studentassess");
  },
  meta: {
    title: "学生质控"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/questionnaireList",
  name: "questionnaireList",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/questionnaireList");
  },
  meta: {
    title: "调查问卷列表"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/questionnaireGradelist",
  name: "questionnaireGradelist",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/questionnaireGradelist");
  },
  meta: {
    title: "问卷质控"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/questionnaireStudentlist",
  name: "questionnaireStudentlist",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/questionnaireStudentlist");
  },
  meta: {
    title: "学生列表"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/personQuality",
  name: "personQuality",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/personQuality");
  },
  meta: {
    title: "人员质控"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/screenerList",
  name: "screenerList",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/screenerList");
  },
  meta: {
    title: "筛查员信息"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/screenerQuData",
  name: "screenerQuData",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/screenerQuData");
  },
  meta: {
    title: "筛查员检测数据"
  },
  hidden: true
}, {
  path: "/h5/qualityQuestionnaire/screenerDetail",
  name: "screenerDetail",
  component: function component() {
    return import("@/views/h5/qualityQuestionnaire/screenerDetail");
  },
  meta: {
    title: "筛查员信息"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/home",
  name: "askForLeaveHome",
  component: function component() {
    return import("@/views/h5/askForLeave/home");
  },
  meta: {
    title: "学生晨午检上报"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/list",
  name: "askForLeaveList",
  component: function component() {
    return import("@/views/h5/askForLeave/applyList");
  },
  meta: {
    title: "请假/销假"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/detail",
  name: "askForLeaveDetail",
  component: function component() {
    return import("@/views/h5/askForLeave/detail");
  },
  meta: {
    title: "申请详情"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/leave",
  name: "askForLeavePage",
  component: function component() {
    return import("@/views/h5/askForLeave/leave");
  },
  meta: {
    title: "请假"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/cancelLeave",
  name: "askForLeaveCancel",
  component: function component() {
    return import("@/views/h5/askForLeave/cancelLeave");
  },
  meta: {
    title: "销假"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/binding",
  name: "askForLeaveBinding",
  component: function component() {
    return import("@/views/h5/askForLeave/binding");
  },
  meta: {
    title: "家长绑定"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/messageList",
  name: "askForLeaveMessageList",
  component: function component() {
    return import("@/views/h5/askForLeave/messageList");
  },
  meta: {
    title: "消息通知"
  },
  hidden: true
}, {
  path: "/h5/askForLeave/messageDetail",
  name: "askForLeaveMessageDetail",
  component: function component() {
    return import("@/views/h5/askForLeave/messageDetail");
  },
  meta: {
    title: "消息详情"
  },
  hidden: true
},
// 校医消息通知路由
{
  path: "/h5/schoolDoctor/messageList",
  name: "schoolDoctorMessageList",
  meta: {
    title: "消息列表"
  },
  component: function component() {
    return import("@/views/h5/schoolDoctor/messageList");
  },
  hidden: true
}, {
  path: "/h5/schoolDoctor/messageDetail",
  name: "schoolDoctorMessageDetail",
  meta: {
    title: "消息通知"
  },
  component: function component() {
    return import("@/views/h5/schoolDoctor/messageDetail");
  },
  hidden: true
}, {
  path: "/h5/schoolDoctor/messageYjcz",
  name: "schoolDoctorMessageDetailYjcz",
  meta: {
    title: "预警处置方案"
  },
  component: function component() {
    return import("@/views/h5/schoolDoctor/messageYjcz");
  },
  hidden: true
}, {
  path: "/h5/searchTwo",
  name: "searchTwo",
  meta: {
    title: "查报告"
  },
  component: function component() {
    return import("@/views/h5/data-search/components/searchTwo");
  },
  hidden: true
}, {
  path: "/h5/article/detail",
  meta: {
    title: "文章详情"
  },
  component: function component() {
    return import("@/views/h5/article/detail");
  },
  hidden: true
}, {
  path: "/h5/article/list",
  meta: {
    title: "动态"
  },
  component: function component() {
    return import("@/views/h5/article/list");
  },
  hidden: true
}, {
  path: "/h5/missingitems/gradelist",
  meta: {
    title: "年级班级列表"
  },
  component: function component() {
    return import("@/views/h5/missingitems/gradeList");
  },
  hidden: true
}, {
  path: "/h5/missingitems/studentlist",
  meta: {
    title: "学生列表"
  },
  component: function component() {
    return import("@/views/h5/missingitems/studentList");
  },
  hidden: true
}, {
  path: "/h5/missingitems/detail",
  meta: {
    title: "中小学生健康体检未检测项"
  },
  component: function component() {
    return import("@/views/h5/missingitems/detail");
  },
  hidden: true
}, {
  path: "/h5/missingitems",
  meta: {
    title: "筛查记录"
  },
  component: function component() {
    return import("@/views/h5/missingitems/index");
  },
  hidden: true
}, {
  path: "/h5/errorstatistics",
  meta: {
    title: "数据看板"
  },
  component: function component() {
    return import("@/views/h5/qualityControl/errorStatistics");
  },
  hidden: true
}, {
  path: "/h5/errorStatisticsGrade",
  meta: {
    title: "数据看板"
  },
  component: function component() {
    return import("@/views/h5/qualityControl/errorStatisticsGrade");
  },
  hidden: true
}, {
  path: "/h5/errorStatisticsStu",
  meta: {
    title: "数据看板"
  },
  component: function component() {
    return import("@/views/h5/qualityControl/errorStatisticsStu");
  },
  hidden: true
}, {
  path: "/h5/test/clear",
  meta: {
    title: '清除缓存'
  },
  component: function component() {
    return import('@/views/test/clear');
  },
  hidden: true
}, {
  path: "/h5/devices/sn",
  meta: {
    title: "选择设备SN"
  },
  component: function component() {
    return import("@/views/h5/online-devices/devices-sn-choose");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/binding",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/binding");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/head-teacher-login",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/head-teacher-login");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/children",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/children");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/clazz",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/clazz");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/clazz-card",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/clazz-card");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/child-card",
  meta: {
    title: "眼健康打卡"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/child-card");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/informed-consent-form",
  meta: {
    title: "儿童远视储备筛查及阳光打卡项目知情同意书"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/informed-consent-form/index");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction",
  meta: {
    title: "近期视力健康指数"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/index");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/health-status",
  meta: {
    title: "健康状况"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/health-status");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/pregnancy-factors",
  meta: {
    title: "孕期因素"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/pregnancy-factors");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/family-vision",
  meta: {
    title: "家族视力"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/family-vision");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/eye-habits",
  meta: {
    title: "用眼习惯"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/eye-habits");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/eye-environment",
  meta: {
    title: "用眼环境"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/eye-environment");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/myopia-intervention",
  meta: {
    title: "近视干预"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/myopia-intervention");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/dietary-intake",
  meta: {
    title: "饮食摄入"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/dietary-intake");
  },
  hidden: true
}, {
  path: "/h5/tr-myopia-prediction/edit/sleep-status",
  meta: {
    title: "睡眠状况"
  },
  component: function component() {
    return import("@/views/h5/tr-myopia-prediction/edit/sleep-status");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/report",
  meta: {
    title: "眼科检查报告"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/report");
  },
  hidden: true
}, {
  path: "/h5/eyehealthcheckin/question",
  meta: {
    title: "眼科检查报告"
  },
  component: function component() {
    return import("@/views/h5/eye-health-check-in/question");
  },
  hidden: true
}, {
  path: "/h5/qualityControl/quality-control-record",
  meta: {
    title: "质控记录"
  },
  component: function component() {
    return import("@/views/h5/qualityControl/quality-control-record");
  },
  hidden: true
}, {
  path: "/h5/screener/grade-class-list",
  component: function component() {
    return import("@/views/h5/screener/grade-class-list");
  },
  meta: {
    // 年级班级
    title: ""
  },
  hidden: true
}, {
  path: "/h5/screener/student-list",
  component: function component() {
    return import("@/views/h5/screener/student-list");
  },
  meta: {
    // 班级学生列表
    title: ""
  },
  hidden: true
}, {
  path: "/h5/screener/add-archive",
  component: function component() {
    return import("@/views/h5/screener/add-archive");
  },
  meta: {
    title: "添加档案"
  },
  hidden: true
}, {
  //未实现完成的路由，勿动
  path: "/h5/mine/screenRecords",
  meta: {
    title: "筛查记录"
  },
  component: function component() {
    return import("@/views/h5/mine/screen-records");
  },
  hidden: true
}, {
  //未实现完成的路由，勿动
  path: "/h5/mine/screenRecordsQuality",
  meta: {
    title: "质检考核"
  },
  component: function component() {
    return import("@/views/h5/mine/screen-records-quality");
  },
  hidden: true
}, {
  path: "/h5/data-collection",
  meta: {
    title: "数据采集"
  },
  component: function component() {
    return import("@/views/h5/data-collection/index");
  },
  hidden: true
}, {
  path: "/h5/ai",
  meta: {
    title: "护眼助手"
  },
  component: function component() {
    return import("@/views/h5/ai");
  },
  hidden: true
}, {
  path: "/h5/screener/immessage-list",
  name: "immessage-list",
  component: function component() {
    return import("@/views/h5/screener/immessage-list");
  },
  meta: {
    title: "消息"
  },
  hidden: true
}, {
  path: "/h5/screener/immessage-chat-system",
  name: "immessage-chat-system",
  component: function component() {
    return import("@/views/h5/screener/immessage-chat-system");
  },
  meta: {
    title: "系统消息"
  },
  hidden: true
}, {
  path: "/h5/screener/immessage-help",
  name: "immessage-help",
  component: function component() {
    return import("@/views/h5/screener/immessage-help");
  },
  meta: {
    title: "帮助"
  },
  hidden: true
}, {
  path: "/h5/screener/aikf",
  component: function component() {
    return import("@/views/h5/screener/aikf");
  },
  meta: {
    title: "AI客服"
  },
  hidden: true
},
// 缺失学生列表 请保留
{
  path: "/h5/screener/student-list-missing",
  component: function component() {
    return import("@/views/h5/screener/student-list-missing");
  },
  meta: {
    title: ""
  },
  hidden: true
}, {
  path: "/h5/questionnaire-parent-jtqk-v2025",
  meta: {
    title: "家庭情况调查问卷-家长填写"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire-parent-jtqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire-parent-jksy-v2025",
  meta: {
    title: "健康素养监测问卷-家长填写"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire-parent-jksy-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire-child-jksy-v2025",
  meta: {
    title: "健康素养监测问卷-学生填写"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire-child-jksy-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire-teacher-jsqk-v2025",
  meta: {
    title: "教师职业压力调查问卷"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire-teacher-jsqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/questionnaire-child-xlqk-v2025",
  meta: {
    title: "心理情况问卷-学生填写"
  },
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/questionnaire-child-xlqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/report-all-status",
  meta: {
    title: "评估报告"
  },
  //评估报告列表统计
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-all-status");
  },
  hidden: true
}, {
  path: "/h5/report-child-xlqk-v2025",
  meta: {
    title: "中小学生心理健康情况调查问卷"
  },
  //心理情况问卷报告-学生填写
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-child-xlqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/report-child-jksy-v2025",
  meta: {
    title: "儿童青少年健康素养监测调查问卷"
  },
  //健康素养问卷报告-学生填写
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-child-jksy-v2025");
  },
  hidden: true
}, {
  path: "/h5/report-parent-jtqk-v2025",
  meta: {
    title: "家庭情况及养育实践调查问卷"
  },
  //家庭情况问卷报告-家长填写
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-parent-jtqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/report-parent-jksy-v2025",
  meta: {
    title: "家长健康素养监测调查问卷"
  },
  //健康素养问卷报告-家长填写
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-parent-jksy-v2025");
  },
  hidden: true
}, {
  path: "/h5/report-teacher-jsqk-v2025",
  meta: {
    title: "教师职业压力调查问卷"
  },
  //教师职业压力问卷报告-班主任填写
  component: function component() {
    return import("@/views/h5/questionnaireNew/questionnaireList/report-teacher-jsqk-v2025");
  },
  hidden: true
}, {
  path: "/h5/screener/register",
  name: "register",
  component: function component() {
    return import("@/views/h5/screener/register");
  },
  meta: {
    title: "注册"
  },
  hidden: true
}, {
  path: "/h5/screener/terms",
  name: "terms",
  component: function component() {
    return import("@/views/h5/screener/terms");
  },
  meta: {
    title: "用户协议"
  },
  hidden: true
}];
export default h5Router;